import { NumberFormatter } from '@mantine/core';
import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { shiftsPageModel } from 'pages/shifts-page/model';
import cls from './shifts-page-card.module.scss';

export type ShiftsPageCardProps = {
	title: string;
	value: number | string;
	withCurrency?: boolean;
	className?: string;
};

export const ShiftsPageCard = ({
	title,
	value,
	withCurrency = true,
	className,
}: ShiftsPageCardProps) => {
	const currency = useUnit(shiftsPageModel.$currency);

	return (
		<div className={clsx(cls.shiftsPageCard, className)}>
			<h3 className={cls.shiftsPageCardTitle}>{title}</h3>
			<div className={cls.shiftsPageCardBody}>
				{withCurrency && <span className={cls.shiftsPageCardCurrency}>{currency} </span>}
				{typeof value === 'string' ? value : <NumberFormatter value={value} />}
			</div>
		</div>
	);
};
